import React, { useState, useEffect } from "react";
import axios from "axios";

const UpdateItem = () => {
  const [items, setItems] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    desc: "",
    price: "",
    category: [],
    availability: false,
    imageUrl: [],
  });
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await axios.get(
          "https://ekhoni-khabo-server.vercel.app/api/v1/menu/get-items"
        );
        setItems(response.data.items);
      } catch (error) {
        console.error("Error fetching items:", error);
      }
    };
    fetchItems();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("authToken");
      await axios.put(
        `https://ekhoni-khabo-server.vercel.app/api/v1/menu/update-item/${selectedItem._id}`,
        {
          ...formData,
          category: formData.category.split(",").map((item) => item.trim()),
          imageUrl: formData.imageUrl.split(",").map((url) => url.trim()),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Attach token to request headers
          },
        }
      );
      setSelectedItem(null); // Close modal after update
      window.location.reload(); // Refresh items
    } catch (error) {
      console.error("Error updating item:", error);
    }
  };

  const openModal = (item) => {
    setSelectedItem(item);
    setFormData({
      title: item.title,
      desc: item.desc,
      price: item.price,
      category: item.category.join(","),
      availability: item.availability,
      imageUrl: item.imageUrl.join(","),
    });
  };

  const handleDelete = async (itemId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this item?"
    );
    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("authToken");
      await axios.delete(
        `https://ekhoni-khabo-server.vercel.app/api/v1/menu/delete-item/${itemId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Remove the deleted item from the UI
      setItems(items.filter((item) => item._id !== itemId));
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  return (
    <div className="p-6 w-ull pl-[300px]">
      <h2 className="text-3xl font-bold mb-4">Items List</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((item) => (
          <div key={item._id} className="bg-white shadow-md rounded-lg p-4">
            <img
              src={item.imageUrl[0]}
              alt={item.title}
              className="w-full h-40 object-cover rounded mb-2"
            />
            <h3 className="text-xl font-semibold">{item.title}</h3>
            <h3 className="text-xl font-semibold">{item.category}</h3>
            <div className="flex justify-between">
              <button
                onClick={() => openModal(item)}
                className="mt-4 bg-blue-500 text-white py-2 px-4 rounded"
              >
                Update
              </button>
              <button
                onClick={() => handleDelete(item._id)}
                className="mt-4 bg-red-500 text-white py-2 px-4 rounded"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Form to Update Item */}
      {selectedItem && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-md w-1/3">
            <h2 className="text-2xl font-semibold mb-4">Update Item</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Title"
                className="w-full p-2 border rounded"
                required
              />
              <input
                name="desc"
                value={formData.desc}
                onChange={handleChange}
                placeholder="Description"
                className="w-full p-2 border rounded"
                required
              />
              <input
                name="price"
                value={formData.price}
                onChange={handleChange}
                placeholder="Price"
                className="w-full p-2 border rounded"
                required
              />
              <input
                name="category"
                value={formData.category}
                onChange={handleChange}
                placeholder="Categories (comma separated)"
                className="w-full p-2 border rounded"
                required
              />
              <input
                name="imageUrl"
                value={formData.imageUrl}
                onChange={handleChange}
                placeholder="Image URLs (comma separated)"
                className="w-full p-2 border rounded"
                required
              />
              <label className="flex items-center">
                <input
                  type="checkbox"
                  name="availability"
                  checked={formData.availability}
                  onChange={handleChange}
                  className="mr-2"
                />{" "}
                Available
              </label>
              <button
                type="submit"
                className="w-full bg-green-500 text-white py-2 rounded"
              >
                Update Item
              </button>
              <button
                type="button"
                onClick={() => setSelectedItem(null)}
                className="mt-4 w-full bg-red-500 text-white py-2 rounded"
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateItem;
